<script setup></script>

<template>

  <div>
    <p class="typingEffect">
    </p>
  </div>

</template>

<style scoped>
code {
  background-color: #202129;
  border-radius: 4px;
  padding: 20px;
  height: 70px;
  color: white;
  display: flex;
  margin: 0 auto;
  align-items: center;
  width: 350px;
}

.typingEffect {
  overflow: hidden;
  border-right: 2px solid white;
  font-size: 16px;
  white-space: normal;
  animation: typing 2s forwards;
}

@keyframes typing {
  from {
    width: 0
  }

  to {
    width: 100%
  }
}
</style>